// web-vitals v5 API — the v2-era getCLS/getFID/... names this file used to
// import were removed in v3+ (package.json pins ^5.1.0), so this was
// silently broken. FID is also retired as of March 2024; onINP replaces it
// as the third Core Web Vital alongside LCP and CLS.
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
